// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__OyGzV","col":"CardReaderDesc_col__2pVDv","label":"CardReaderDesc_label__36HYV"};